import api from './api';

export const path = '/account';

export const loginRequest = (values) => api.post(`${path}/login`, values);
export const signupRequest = (values) => api.post(`${path}/signup`, values);
export const forgotPasswordRequest = (email) =>
    api.post(`${path}/forgot/password`, email);
export const newPasswordRequest = (values) =>
    api.post(`${path}/new/password`, values);
export const newPhoneRequest = (values) =>
    api.post(`${path}/new/phone`, values);

export const getNewAccessTokenRequest = (refreshToken) =>
    api.post(`${path}/refreshToken`, { refreshToken });

export const logoutRequest = (accountId) => {
    return api.delete(`${path}/logout`, {
        params: {
            accountId,
        },
    });
};

export const getAccountByIdRequest = (accountId) =>
    api.get(`${path}/accountId`, {
        params: {
            accountId,
        },
    });

export const getCompanyByIdRequest = (accountId) =>
    api.get(`${path}/companyId`, {
        params: {
            accountId,
        },
    });

export const completeGoogleRequest = (values) => {
    const accessToken = localStorage.getItem('accessToken');
    return api.post(`${path}/complete-google`, values, {
        headers: { Authorization: `Bearer ${accessToken}` },
    });
};
